import styled from "styled-components";
import { Modal } from "./Modal";
import { Button } from "./Button";
import { FormActions } from "./FormActions";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";
import { spacing } from "@styling/sizing";

const Message = styled.p`
  margin: 0 0 ${spacing.x3}px 0;
  font-size: ${fontSizes.regular}px;
  line-height: 1.5;
  color: ${colors.text};
`;

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  danger,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} maxWidth={440}>
      <Message>{message}</Message>
      <FormActions>
        <Button type="button" $color="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button
          type="button"
          $color={danger ? "danger" : "primary"}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </FormActions>
    </Modal>
  );
};
